import {
  Container,
  SimpleGrid,
  Box,
  Heading,
  Icon,
  Body,
} from '@hover/blueprint';
import React from 'react';
import { iCheckCircle } from '@hover/icons';
import ButtonsGroup from './ButtonsGroup';
import InsuranceResolutionVector from '../../../assets/svgs/InsuranceResolutionVector';

const Resolution: React.FC = () => (
  <Container
    px={{ base: 500, tablet: 0 }}
    maxW={{ base: 'xl', desktop: '1200px' }}
    mb={{ base: 700, desktop: 1100 }}
  >
    <SimpleGrid columns={{ base: 1, desktop: 2 }} alignItems="center">
      <Box
        pl={{ base: 0, desktop: 500 }}
        flexDir="column"
        maxW={{ base: '100%', desktop: '500px' }}
      >
        <Body isBold size={200} color="neutral.600" mb={200}>
          RESOLUTION
        </Body>
        <Heading size={{ base: 500, tablet: 600 }} style={{ marginBottom: 0 }}>
          Boost policyholder satisfaction
        </Heading>
        <Body mt={200} mb={700}>
          A faster process means policyholders can restore their homes more
          quickly. Detailed estimates with damage documentation help homeowners
          and contractors trust the resolution.
        </Body>
        <Box flexDir="row" mb={400}>
          <Icon
            m={0}
            mr={500}
            color="brandNavy.500"
            icon={iCheckCircle}
            size="default"
            minBlockSize="24px"
          />
          <Body flex={1} size={500} color="neutral.600" isSemiBold>
            Quicker conversations with contractors
          </Body>
        </Box>
        <Box flexDir="row">
          <Icon
            m={0}
            mr={500}
            color="brandNavy.500"
            icon={iCheckCircle}
            size="default"
            minBlockSize="24px"
          />
          <Body flex={1} size={500} color="neutral.600" isSemiBold>
            Faster claim resolutions
          </Body>
        </Box>
        <ButtonsGroup />
      </Box>
      <Container px={0} maxW="xl" centerContent>
        <Box position="relative" w="100%" maxW="440px" maxH="412px">
          <InsuranceResolutionVector />
          <Box position="absolute" top="100px" left="65px" flexDir="column">
            <Body color="primary.200" size={200} isBold mb={200}>
              Carrier’s average cycle time:
            </Body>
            <Heading
              color="primary.200"
              size={{ base: 600, tablet: 700, desktop: 800 }}
              isDisplay
              marginBottom="56px"
              as="p"
            >
              7-10 days
            </Heading>
            <Body color="primary.200" size={200} isBold mb={200}>
              Cycle time after HOVER invite:
            </Body>
            <Heading
              as="p"
              color="primary.200"
              size={{ base: 600, tablet: 700, desktop: 800 }}
              isDisplay
            >
              2:05 hours
            </Heading>
          </Box>
        </Box>
      </Container>
    </SimpleGrid>
  </Container>
);

export default Resolution;
